export default __webpack_public_path__ + "static/media/tele.5aa252f5.svg";